export const CHANGE_SELECTED_STRUCTURE = "CHANGE_SELECTED_STRUCTURE";
export const RESET_STRUCTURES_STATE = "RESET_STRUCTURES_STATE";

export const changeSelectedStructure = (id, name) => ({
  type: CHANGE_SELECTED_STRUCTURE,
  payload: {
    structureID: id,
    structureName: name,
  },
});

export const resetStructuresState = () => ({
  type: RESET_STRUCTURES_STATE,
});
